<template>
    <div id="dashboard-customer-pie-chart" class="echarts"></div>
</template>

<script>
    import * as echarts from 'echarts';
    import { EventBus } from '@/assets/js/event-bus'

    export default {
        name: "PieChart",
        props: {
            dataList: {},
        },
        watch: {
            dataList: {
                handler: function(val, oldVal) {
                    this.$nextTick(function() {
                        this.drawChart(val)
                    })
                },
                deep: true
            }
        },
        mounted() {
        },
        methods: {
            drawChart(__dataList) {

                var chartDom = document.getElementById("dashboard-customer-pie-chart");
                var myChart = echarts.init(chartDom);
                myChart.clear();
                var option = {
                    title: {
                        text: "近30天报告数量分布图",
                        top: 15,
                        left: '50%'
                    },
                    tooltip: {
                        trigger: 'item'
                    },
                    legend: {
                        orient: 'vertical',
                        top: 15,
                        left: '15'
                    },
                    series: [
                        {
                            right: '-60',
                            center: ['60%', '55%'],
                            name: "报告数量",
                            type: 'pie',
                            radius: ['20%', '70%'],
                            avoidLabelOverlap: false,
                            itemStyle: {
                                borderRadius: 4,
                                borderColor: '#fff',
                                borderWidth: 2
                            },
                            label: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: '20',
                                    fontWeight: 'bold'
                                }
                            },
                            labelLine: {
                                show: true,
                                position: "outside"
                            },
                            data: __dataList
                        }
                    ]
                };

                option && myChart.setOption(option);


                window.addEventListener('resize', function() {
                    myChart.resize()
                })
                EventBus.$on('resize', () => {
                    setTimeout(() => {
                        myChart.resize()
                    }, 300) // 折叠动画效果为300ms
                })
            }
        }
    }




</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/echarts/PieChart.vue